<template>
    <div class="page page-pai_hang_bang pr" >
        <div class="list top">
            <div class="clearfix" >
                <div class="index fl ">
                    <span class="f-red">{{data.no}}</span><br/>名次
                </div>
                <div class="nickname pa">
                    <img class="pic" :src="data.avatar || default_user" alt="">
                    <div class="nick-text">{{data.nickName}}</div>
                    <div class="grade to">{{data.levelName}}</div>
                </div>
                
                <div class="points fr"><span class="f-red">{{data.score}}</span><br/>分数</div>
            </div>
        </div>
      
        <div class="list">
            <div class="list-item list-title clearfix">
                <div class="el index">排名</div>
                <div class="el nickname to">昵称</div>
                <div class="el grade to">等级</div>
                <div class="el points">分数</div>
            </div>
            <div class="list-item clearfix" v-for="(item, index) in data.userList" :key="index">
                <div class="el index">
                    <img v-if="index==0" src="@/assets/image/rank_1.png" alt=""/>
                    <img v-if="index==1" src="@/assets/image/rank_2.png" alt=""/>
                    <img v-if="index==2" src="@/assets/image/rank_3.png" alt=""/>
                    <div v-if="index > 2">{{item.no}}</div>
                </div>
                <div class="el nickname to">
                    <!-- <img class="pic" :src="item.avatar || default_user" alt=""> -->
                    {{item.nickName}}
                </div>
                <div class="el grade to">{{item.levelName}}</div>
                <div class="el points">{{item.score}}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import api from '@/assets/js/api'
import { cookie } from '@/assets/js/utils'
    export default {
        name: "notice",
        data() {
            return {
                actId: 1,
                data: {},
                default_user: require('../../assets/image/default_user.png'),

            }
        },
        methods: {
            async onload(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    self.$message({
                        message: '请先登录'
                    })
                    self.$router.push('/')
                }
                let res = await api({
                    method: 'topUser',
                    token
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                if(code ==200){
                    self.data = data
                }
            },
        },
        mounted() {
            let self =this;
            self.actId = self.query && self.query.__sa || 1;
            this.onload()
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../../assets/css/base.less';
.page-pai_hang_bang {
    padding-top: 80px;
    // margin-top: 20px;
}

.list-item {
        &:last-child {
            border: 0;
        }
        // padding: 10px 0;
        .mr {
            margin-right: 10px;
        }
        border-bottom: 1px solid #ead7b9;
        width: 100%;
        .el {
            line-height: 60px;
            height: 60px;
            float: left;
            text-align: center;
        }
        .index {
            .mr();
            text-align: center;
            width: unit(80 / @page-width * 100, vw);
        }
        .pic {
            width: 40px;
            height: 40px;
            border-radius: 40px;
            border: 1px solid #edb635;
            .mr()
        }
        .nickname {
            width: unit(230 / @page-width * 100, vw);
            .mr()
        }
        .grade {
            text-align: center;
            width: unit(170 / @page-width * 100, vw);
            .mr()
        } 
        .points {
            float: right;
            color: #aa3b31;
        }
    }
.list {
    
    color: #6d5653 !important;
    box-sizing: border-box;
    background-color: #ead7b9;
    margin: 0 auto;
    width: unit(690 / @page-width * 100, vw);
    background-color: #f8eccf;
    padding: unit(35 / @page-width * 100, vw);
    border-radius: 10px;
    .list-title {
        .index {
            width:unit(690 / @page-width * 100, vw);
        }
        .points {
            color: #6d5653 !important;
        }
    }
    .list-item {
        &:last-child {
            border: 0;
        }
        // padding: 10px 0;
        .mr {
            margin-right: 10px;
        }
        border-bottom: 1px solid #ead7b9;
        width: 100%;
        .el {
            line-height: 60px;
            height: 60px;
            float: left;
            text-align: center;
        }
        .index {
            .mr();
            text-align: center;
            width: unit(80 / @page-width * 100, vw);
        }
        .pic {
            width: 40px;
            height: 40px;
            border-radius: 40px;
            border: 1px solid #edb635;
            .mr()
        }
        .nickname {
            width: unit(230 / @page-width * 100, vw);
            .mr()
        }
        .grade {
            text-align: center;
            width: unit(170 / @page-width * 100, vw);
            .mr()
        } 
        .points {
            float: right;
            color: #aa3b31;
        }
    }
}
.top {
    text-align: center;
    padding-bottom: 20px;

    .nickname {
        margin: 0 auto;
        top: 40px;
        left: 50%;
        width: 120px;
        height: 66px;
        margin-left: -60px;
        .pic {
            width: 64px;
            height: 64px;
            margin: 0 auto;
            border-radius: 100px;
            border: 1px solid @c-y;
        }
        .grade {
            position: absolute;
            top: 55px;
            left: 0;
            background-size: 100% 100%;
            width: 120px;
            height: 24px;
            background-image: url(../../assets/image/rank_t.png);
        }
        .nick-text {
            padding-top: 20px;
        }
    }
    
    margin-bottom: 20px;
}
</style>